module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/container-canvas/container-canvas.component.html
// module id = ./src/app/modules/common-module/components/container-canvas/container-canvas.component.html
// module chunks = 9